import React, { useContext } from 'react'
import { withTranslation } from 'react-i18next'
import { GrFormClose } from 'react-icons/gr'
import { DepositContext } from '../context'

function SingleDepositDetails({ t }) {
    const { displaySingleDeposit, setDisplaySingleDeposit, singleDepositsData } = useContext(DepositContext)

    const RenderList = () => {
        const { date, transaction, username, email, description, formatted_gross_amount, reward_used, fee, status } = singleDepositsData
        const names = ['Date', 'Type', 'Customer name', 'Email ', 'Description', 'Deposit amount (NGN)', 'Reward used (NGN)', 'Fee (NGN)', 'Status']
        const values = [date, transaction, username, email, description, formatted_gross_amount, reward_used, fee, status]
        return names.map((name, i) => {
            return (
                <div key={i} className={`h-[7vh] w-[90%] mx-auto flex items-center  border-b-[1px]`}>
                    <div className='w-[47%] text-[#657585] font-[16px] font-[400]'>
                        {name}
                    </div>
                    <div className='w-[47%] text-[#05213D] font-[16px] font-[400]'>
                        {
                            name === 'Status' ?
                                (values[i] === 'completed' ?
                                    <div className='border border-success text-success rounded-md text-center text- w-[100px] py-2' style={{ background: 'rgba(68, 196, 161, 0.12) ' }}>
                                        {values[i]}
                                    </div>
                                    :
                                    <div className='border border-danger text-danger rounded-md text-center text- w-[100px] py-2'>
                                        {values[i]}
                                    </div>
                                )
                                :
                                (values[i])
                        }
                    </div>
                </div>
            )
        })
    }

    return (
        <div className={`h-[100vh] w-[100vw] left-[0] top-[0] ${displaySingleDeposit ? 'hidden' : ''}`}
            style={{ position: 'fixed', zIndex: 100, backgroundColor: 'rgba(0,0,0,.6)' }} >
            <div
                className=' left-[50%] top-[50%] bg-white absolute h-[auto] lg:w-[30vw] xs:w-[100vw] rounded-[16px] border'
                style={{ transform: 'translate(-50%,-50%)', overflowY: 'auto', zIndex: 1000, }}>
                <div className='w-[100%] h-[auto]'>
                    <div className='h-[8vh] w-[100%] flex items-center justify-center border-b-[1px] font-[20px] text-[#05213D] font-[700] reltive'>
                        Deposit Details
                        <div
                            onClick={() => setDisplaySingleDeposit(!displaySingleDeposit)}
                            className='absolute right-[2vw] bg-[#F5F6FA] btn w-[30px] h-[30px] flex items-center justify-center font-[400] font-[80%]'
                            style={{ borderRadius: '100%', cursor: 'pointer' }} > <GrFormClose size={20} color='#96A4B2' /> </div>
                    </div>
                    <RenderList />
                </div>
            </div>
        </div >
    )
}

export default withTranslation()(SingleDepositDetails)
